// Minimal, safe-ish Markdown → HTML renderer for AI bubbles. Supports:
//   **bold**  →  <strong>
//   *italic*  →  <em>
//   `code`    →  <code>
//   ## heading → <strong>
//   newline   →  <br />
// Everything else is escaped so no injection can happen.
function escapeHtml(s) {
  return (s || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function renderMarkdown(input) {
  if (!input) return "";
  const safe = escapeHtml(String(input));
  return safe
    // headings (## foo → bold big)
    .replace(/^###\s+(.+)$/gm, '<strong class="block mt-2 mb-1 text-[#1F3A5F]">$1</strong>')
    .replace(/^##\s+(.+)$/gm, '<strong class="block mt-2 mb-1 text-[#1F3A5F]">$1</strong>')
    .replace(/^#\s+(.+)$/gm, '<strong class="block mt-2 mb-1 text-[#1F3A5F]">$1</strong>')
    // bold + italic combinations
    .replace(/\*\*\*(.+?)\*\*\*/g, "<strong><em>$1</em></strong>")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, "$1<em>$2</em>")
    .replace(/`([^`]+)`/g, '<code class="px-1 py-0.5 rounded bg-neutral-100 text-[#E5276A] text-[12px]">$1</code>')
    // lists (- item or • item)
    .replace(/^\s*[-•]\s+(.+)$/gm, '<span class="block pl-3">• $1</span>')
    // newlines
    .replace(/\n/g, "<br />");
}
